exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alm-markdown-root{font-size:.7em}.alm-markdown-root p{margin-top:.5em;margin-bottom:.5em}.alm-markdown-root a{color:grey}.alm-markdown-root a:hover{color:#fff}.alm-markdown-root ul{margin:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/markdown/markdown.css
 ** module id = 190
 ** module chunks = 0
 **/